/**
 * Action types for network Alarm Configation functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_NETWORK_CONFIG = 'GET_NETWORK_CONFIG';
export const GET_NETWORK_CONFIG_SUCCESS = 'GET_NETWORK_CONFIG_SUCCESS';
export const GET_NETWORK_CONFIG_FAIL = 'GET_NETWORK_CONFIG_FAIL';
export const EDIT_NETWORK_CONFIG = 'EDIT_NETWORK_CONFIG'
export const EDIT_NETWORK_CONFIG_COMPLETE =  'EDIT_NETWORK_CONFIG_COMPLETE';